import { PillTheme } from "../pill-theme";

export enum CustomerTagSource {
  REDO_SUPPORT = "redo-support",
  SHOPIFY = "shopify",
  REDO_MARKETING = "redo-marketing",
}

/**
 * A tag's provider has authority to add/remove that tag.
 * When we update tags on a customer, we will also notify
 * each tag's provider of the change.
 */
export enum CustomerTagProvider {
  REDO = "redo",
  COMMENTSOLD = "commentsold",
  SHOPIFY = "shopify",
}

export interface CustomerTagRecord {
  _id: string;
  teamId: string;
  name: string;
  pillTheme: PillTheme;
  source: CustomerTagSource;
  provider?: CustomerTagProvider | null;
  externalTagType?: string | null;
}
